/**
 * Labstep
 *
 * @module components/Entity/Action/View
 * @desc Core view action
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { EntityActionViewProps } from './types';

export const EntityActionView: React.FC<EntityActionViewProps> = ({
  entityName,
  params,
  history,
  actionComponentProps,
  dataCy,
}) => {
  const onClick = () =>
    history.push(navigation.get(`${entityName}_show`, params));

  return (
    <ActionComponent
      dataCy={dataCy}
      type="option"
      text="View"
      icon="eye"
      onClick={onClick}
      {...actionComponentProps}
    />
  );
};

export default withRouter(EntityActionView);
